<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme white--text">
          <v-icon class="white--text">local_offer</v-icon>
          <div class="headline ml-2 ">Manage your marketplace listing and offers</div>
          <v-spacer />
          <v-btn
            v-if="isApproved"
            @click="providerProfile"
            depressed
            class="action rounded-sm white--text"
            >View Public profile</v-btn
          >
        </v-card-title>
        <v-card-text>
          <div v-if="isApproved" class="mt-4">
            <v-row>
              <v-col cols="12" lg="3">
                <v-avatar v-if="provider.logo_url" size="200" tile>
                  <v-img :src="provider.logo_url" />
                </v-avatar>
                <div class="mt-5">
                  <v-btn
                    depressed
                    class="action rounded-sm white--text"
                    @click="showProviderInfo"
                    >Update Info</v-btn
                  >
                </div>
              </v-col>
              <v-col cols="12" lg="9">
                <div class="body-1 ml-4">
                  This information will be part of your company listing in the
                  marketplace.
                </div>
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td>Name</td>
                        <td>{{ provider.name }}</td>
                      </tr>
                      <tr>
                        <td>Website</td>
                        <td>{{ provider.url }}</td>
                      </tr>
                      <tr>
                        <td>Partnership status</td>
                        <td>{{ provider.status }}</td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>{{ provider.contact_email }}</td>
                      </tr>
                      <tr>
                        <td>Location</td>
                        <td>{{ provider.location }}</td>
                      </tr>
                      <tr>
                        <td>Address</td>
                        <td>
                          {{
                            provider.address_line_1
                              ? provider.address_line_1
                              : ""
                          }}
                          {{
                            provider.address_line_2
                              ? `, ${provider.address_line_2}`
                              : ""
                          }}
                          {{ provider.city ? `, ${provider.city}` : "" }}
                          {{ provider.state ? `, ${provider.state}` : "" }}
                          {{
                            provider.post_code ? `, ${provider.post_code}` : ""
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </div>
          <div v-else class="mt-4">
            <span class="body-1">
              If you’d like to promote your company and products on the
              community marketplace, please apply below.
            </span>
            <div class="mt-5">
              <v-btn
                class="action rounded-sm white--text"
                @click="showProviderInfo"
                >Apply here</v-btn
              >
            </div>
          </div>
        </v-card-text>
      </v-card>

      <v-card v-if="isApproved" class="mt-4">
        <v-card-title class="theme">
          <span class="title white--text">Your offers</span>
          <v-spacer />
          <v-btn
            class="action rounded-sm white--text"
            depressed
            v-if="providerBenefits.benefit_count < 3"
            @click="addNewOffer"
            >Add</v-btn
          >
          <v-btn
            dark
            class="action rounded-sm white--text"
            depressed
            v-else
            :disabled="true"
            >Max Quota reached</v-btn
          >
        </v-card-title>
        <v-card-text class="mt-4">
          <span class="body-1"
            >In order to give back to the community you must provide a unique
            discount or benefit for other members. <br />You can have up to 3
            active product offers.</span
          >
          <v-row v-if="providerBenefits.benefits" class="mt-1">
            <v-col
              cols="12"
              md="4"
              :key="item.id"
              v-for="item in providerBenefits.benefits"
            >
              <v-card outlined>
                <v-card-title class="theme">
                  <div class="white--text title">
                    Status : {{ item.status }}
                  </div>
                  <v-spacer />
                  <v-btn
                    @click="editOffering(item)"
                    depressed
                    class="action rounded-sm white--text"
                    >Edit</v-btn
                  >
                </v-card-title>
                <v-img :src="item.url" v-if="item.url" :height="225" />
                <v-responsive class="grey lighten-1" height="225" v-else>
                  <v-row class="fill-height" align="center" justify="center">
                    <v-icon color="white" style="font-size: 80px"
                      >card_giftcard</v-icon
                    >
                  </v-row>
                </v-responsive>
                <v-divider />
                <v-card-text>
                  <h4 class="theme-text text-capitalize">{{ item.name }}</h4>
                  <div class="body-2 theme-text" v-text="item.title" />
                  <v-list subheader two-line dense class="ml-n4">
                    <v-list-item class="mb-n6">
                      <v-list-item-content>
                        <v-list-item-title>Provider</v-list-item-title>
                        <v-list-item-subtitle v-text="item.provider_name" />
                      </v-list-item-content>
                    </v-list-item>
                    <!-- <v-list-item class="mb-n6">
                      <v-list-item-content>
                        <v-list-item-title>Cost</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ item.cost }} {{ item.currency }} / {{ item.unit }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>-->
                    <v-list-item class="mb-n6">
                      <v-list-item-content>
                        <v-list-item-title>Category</v-list-item-title>
                        <v-list-item-subtitle v-text="item.category" />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="mb-n6">
                      <v-list-item-content>
                        <v-list-item-title>Type</v-list-item-title>
                        <v-list-item-subtitle>{{
                          benefitType(item.type)
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-dialog v-model="showProviderDialog" persistent max-width="800">
        <v-card flat>
          <v-card-title class="headline pt-4 theme white--text">
            <span>Your company information</span>
            <v-spacer />
            <v-btn icon @click="showProviderDialog = !showProviderDialog">
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="my-3 body-2">
            <div class="body-2">
              Your company's information will be sent to our moderators for
              approval. Please provide all the information so that the
              moderators can contact you and get in touch.
            </div>
            <v-form ref="providerForm">
              <v-row>
                <v-col cols="12" md="12" lg="6">
                  <v-text-field
                    class="my-1"
                    label="Name*"
                    :rules="[validationRules.required]"
                    placeholder="Name of the company"
                    autofocus
                    v-model="providerInfo.name"
                  />
                  <v-text-field
                    class="my-1"
                    label="Contact Email*"
                    :rules="[validationRules.required, validationRules.email]"
                    placeholder="Contact email for the company"
                    v-model="providerInfo.contact_email"
                  />
                  <v-autocomplete
                    label="Location"
                    :rules="[validationRules.required]"
                    v-model="providerInfo.location"
                    :items="countries"
                    item-text="name"
                    item-value="name"
                  />
                  <v-text-field
                    class="my-1"
                    label="Website"
                    placeholder="URL for your website"
                    v-model="providerInfo.url"
                  />
                  <v-textarea
                    v-model="providerInfo.description"
                    placeholder="Details about the company"
                    label="Description"
                  />
                </v-col>

                <v-col cols="12" md="12" lg="6">
                  <v-text-field
                    class="my-1"
                    label="Address Line 1*"
                    :rules="[validationRules.required]"
                    placeholder="Address line 1"
                    v-model="providerInfo.address_line_1"
                  />
                  <v-text-field
                    class="my-1"
                    label="Address Line 2"
                    placeholder="Address line 2"
                    v-model="providerInfo.address_line_2"
                  />
                  <v-text-field
                    class="my-1"
                    label="PostCode"
                    placeholder="Postcode"
                    v-model="providerInfo.post_code"
                  />
                  <v-text-field
                    class="my-1"
                    label="City"
                    placeholder="URL for your website"
                    v-model="providerInfo.city"
                  />
                  <v-text-field
                    class="my-1"
                    label="state"
                    placeholder="state for your website"
                    v-model="providerInfo.state"
                  />
                  <v-avatar
                    class="profile"
                    color="grey"
                    size="164"
                    tile
                    v-if="provider.logo_url"
                  >
                    <v-img :src="provider.logo_url"></v-img>
                  </v-avatar>
                  <v-avatar
                    class="profile"
                    color="grey"
                    size="164"
                    tile
                    v-else-if="companyInfo.logoUrl"
                  >
                    <v-img :src="companyInfo.logoUrl"></v-img>
                  </v-avatar>
                  <v-file-input
                    v-model="fileInput"
                    show-size
                    label="Upload an image or logo"
                    accept="image/*"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="save rounded-sm white--text"
              text
              @click="saveProvider"
              >Submit</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="addOfferDialog" persistent max-width="600">
        <v-card>
          <v-card-title class="theme">
            <span class="white--text">Add Benefit Offering</span>
            <v-spacer />
            <v-btn icon @click="addOfferDialog = !addOfferDialog">
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-4">
            <v-form ref="addBenefitForm" valid="valid">
              <v-row>
                <v-col class="pt-2" cols="12">
                  <v-text-field
                    label="Title *"
                    validate-on-blur
                    :rules="[validationRules.required]"
                    clearable
                    v-model="benefit.title"
                    hint="Title that will show up to employees"
                    persistent-hint
                    tabindex="1"
                  />
                  <v-text-field
                    label="Name *"
                    validate-on-blur
                    :rules="[validationRules.required]"
                    clearable
                    v-model="benefit.name"
                    hint="Name of the benefit"
                    persistent-hint
                    tabindex="2"
                  />
                  <v-select
                    v-model="benefit.category"
                    :items="categories"
                    :rules="[validationRules.required]"
                    clearable
                    hint="Chose category of benefit"
                    label="Category*"
                    persistent-hint
                    validate-on-blur
                    tabindex="3"
                  />
                  <v-select
                    v-model="benefit.type"
                    :items="types"
                    :rules="[validationRules.required]"
                    item-text="name"
                    item-value="value"
                    clearable
                    multiple
                    hint="Chose type of benefit"
                    label="Type*"
                    persistent-hint
                    validate-on-blur
                    tabindex="4"
                  />
                  <v-text-field
                    label="Provider name"
                    clearable
                    persistent-hint
                    hint="Name of the provider"
                    v-model="benefit.provider_name"
                    disabled
                  />
                  <v-select
                    v-model="benefit.location"
                    :items="countriesByName"
                    item-text="name"
                    item-value="name"
                    multiple
                    tabindex="5"
                    label="Location*"
                    :rules="[validationRules.required]"
                    validate-on-blur
                    clearable
                    hint="Location where this benefit is valid"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggle">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              benefit.location.length > 0
                                ? 'indigo darken-4'
                                : ''
                            "
                          >
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title> Select All </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip class="my-2" v-if="index >= 0 && index < 10">
                        <span>{{ item }}</span>
                      </v-chip>
                      <span v-if="index === 10" class="grey--text text-caption">
                        (+{{ benefit.location.length - 10 }} others)
                      </span>
                    </template>
                  </v-select>
                  <v-textarea
                    label="Description*"
                    :rules="[validationRules.required]"
                    validate-on-blur
                    persistent-hint
                    hint="Details about the benefit"
                    clearable
                    v-model="benefit.information"
                    tabindex="6"
                  />
                  <v-file-input
                    v-model="fileInput"
                    show-size
                    label="Upload an image or logo"
                    accept="image/*"
                  ></v-file-input>
                  <v-text-field
                    label="Discount code (if applicable)"
                    validate-on-blur
                    persistent-hint
                    clearable
                    hint="If your offering needs a discount code"
                    v-model="benefit.discount_code"
                    tabindex="11"
                  />
                  <v-text-field
                    label="Redirect link (if applicable)"
                    validate-on-blur
                    persistent-hint
                    clearable
                    hint="Link to page where user can use the discount code"
                    v-model="benefit.redirect_link"
                    tabindex="12"
                  />
                </v-col>
              </v-row>
              <v-btn
                depressed
                class="save white--text ml-0 mt-3"
                @click="addBenefit"
                >Save
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editOfferDialog" persistent max-width="600">
        <v-card>
          <v-card-title class="theme">
            <span class="white--text">Edit Benefit Offering</span>
            <v-spacer />
            <v-btn
              depressed
              class="error mx-3 white--text rounded-sm"
              @click="deleteDialog = true"
            >
              Delete
            </v-btn>
            <v-dialog v-model="deleteDialog" persistent max-width="400">
              <v-card>
                <v-card-title class="headline pt-4">
                  <v-spacer />
                  <span>Are you sure?</span>
                  <v-spacer />
                </v-card-title>
                <v-divider />
                <v-card-text class="my-2 text-xs-center">
                  This offer will be deleted. You cannot recover this operation
                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <v-btn
                    color="success"
                    text
                    @click="deleteDialog = !deleteDialog"
                  >
                    cancel
                  </v-btn>
                  <v-spacer />
                  <v-btn color="error" text @click="deleteBenefit"
                    >delete</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn icon @click="editOfferDialog = !editOfferDialog">
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-4">
            <v-form ref="editBenefitForm" valid="valid">
              <v-row>
                <v-col class="pt-2" cols="12">
                  <v-text-field
                    label="Title *"
                    validate-on-blur
                    :rules="[validationRules.required]"
                    clearable
                    v-model="benefit.title"
                    hint="Title that will show up to employees"
                    persistent-hint
                    tabindex="1"
                  />

                  <v-text-field
                    label="Name *"
                    validate-on-blur
                    :rules="[validationRules.required]"
                    clearable
                    v-model="benefit.name"
                    hint="Name of the benefit"
                    persistent-hint
                    tabindex="2"
                  />
                  <v-select
                    v-model="benefit.category"
                    :items="categories"
                    :rules="[validationRules.required]"
                    clearable
                    hint="Chose category of benefit"
                    label="Category*"
                    persistent-hint
                    validate-on-blur
                    tabindex="3"
                  />
                  <v-select
                    v-model="benefit.status"
                    :items="statuses"
                    :rules="[validationRules.required]"
                    clearable
                    hint="Deactivate/Activate Offer"
                    label="Activation status*"
                    persistent-hint
                    validate-on-blur
                    tabindex="3"
                  />
                  <v-select
                    v-model="benefit.type"
                    multiple
                    :items="types"
                    :rules="[validationRules.required]"
                    item-text="name"
                    item-value="value"
                    clearable
                    hint="Chose type of benefit"
                    label="Type*"
                    persistent-hint
                    validate-on-blur
                    tabindex="4"
                  />

                  <v-text-field
                    label="Provider name"
                    clearable
                    persistent-hint
                    hint="Name of the provider"
                    v-model="benefit.provider_name"
                    disabled
                  />
                  <v-select
                    v-model="benefit.location"
                    :items="countriesByName"
                    item-value="name"
                    item-text="name"
                    multiple
                    tabindex="5"
                    label="Location*"
                    :rules="[validationRules.required]"
                    validate-on-blur
                    clearable
                    persistent-hint
                    hint="Location where this benefit is valid"
                    class="text"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggle">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              benefit.location.length > 0
                                ? 'indigo darken-4'
                                : ''
                            "
                          >
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title> Select All </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip class="my-2" v-if="index >= 0 && index < 10">
                        <span>{{ item }}</span>
                      </v-chip>
                      <span v-if="index === 10" class="grey--text text-caption">
                        (+{{ benefit.location.length - 10 }} others)
                      </span>
                    </template>
                  </v-select>
                  <v-textarea
                    label="Description*"
                    :rules="[validationRules.required]"
                    validate-on-blur
                    persistent-hint
                    hint="Details about the benefit"
                    clearable
                    v-model="benefit.information"
                    tabindex="6"
                  />

                  <v-file-input
                    v-model="fileInputEdit"
                    show-size
                    label="Upload an image or logo"
                    accept="image/*"
                  ></v-file-input>
                  <v-text-field
                    label="Discount code (if applicable)"
                    validate-on-blur
                    persistent-hint
                    clearable
                    hint="If your offering needs a discount code"
                    v-model="benefit.discount_code"
                    tabindex="11"
                  />
                  <v-text-field
                    label="Redirect link (if applicable)"
                    validate-on-blur
                    persistent-hint
                    clearable
                    hint="Link to page where user can use the discount code"
                    v-model="benefit.redirect_link"
                    tabindex="12"
                  />
                </v-col>
              </v-row>
              <v-btn
                depressed
                class="save white--text ml-0 mt-3"
                @click="saveOffering"
                >Save
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Protected.Benefit.Provider.Info,
  data: () => ({
    breadcrumbs: Breadcrumbs.Benefit.Provider,
    isApproved: false,
    providerInfo: {},
    showProviderDialog: false,
    addOfferDialog: false,
    editOfferDialog: false,
    benefit: {},
    categories: Constants.Benefits.Category.All,
    units: Constants.Benefits.Unit.All,
    types: Constants.Benefits.Type.Select2,
    statuses: Constants.Benefits.Status.All,
    fileInput: [],
    fileInputEdit: [],
    deleteDialog: false,
    selectedLocation: [],
    countriesByName: [],
  }),
  computed: {
    ...mapGetters([
      "userInfo",
      "countries",
      "provider",
      "providerBenefits",
      "companyInfo",
    ]),
    allCountries() {
      return this.benefit.location.length === this.countries.length;
    },
    someCountries() {
      return this.benefit.location.length > 0 && !this.allCountries;
    },
    icon() {
      if (this.allCountries) {
        return "check_box";
      }
      if (this.someCountries) {
        return "check_box_outline_blank";
      }
      return "check_box_outline_blank";
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.allCountries) {
          this.benefit.location = [];
        } else {
          this.benefit.location = this.countries.map((e) => e.name);
        }
      });
    },
    deleteBenefit() {
      if (!this.benefit.id || this.userInfo.role !== Constants.Roles.HR) {
        return false;
      }
      this.deleteDialog = false;
      this.$store
        .dispatch(Actions.Benefits.DeleteProviderBenefits, this.benefit.id)
        .then(() => {
          this.editOfferDialog = false;
          this.setup();
        })
        .catch((err) => {
          console.error(Constants.Benefits.Messages.Error.Delete, err);
          this.snackbarMessage = Constants.Benefits.Messages.Error.Delete;
          this.snackbar = true;
        });
    },
    benefitType(type) {
      if (type) {
        return type.length === 1
          ? this.types.filter((e) => e.value == type[0]).map((e) => e.name)[0]
          : this.types[1].name;
      } else {
        return this.types[1].name;
      }
    },
    editOffering(item) {
      this.benefit = item;
      this.editOfferDialog = true;
    },
    saveOffering() {
      if (!this.$refs.editBenefitForm.validate()) {
        return false;
      }

      if (
        this.fileInputEdit.length !== 0 &&
        !Array.isArray(this.fileInputEdit)
      ) {
        const data = this.fileSetup(this.fileInputEdit, "editProviderBenefits");
        this.$store.dispatch(Actions.Firebase.UploadImage, data).then((r) => {
          if (r.status === 200) {
            this.editOfferDialog = false;
            this.benefit = {};
            this.setup();
          }
        });
        return;
      }

      const payload = {
        id: this.benefit.id,
        data: {
          ...this.benefit,
          type: this.benefit.type.map((e) => e),
        },
      };
      this.$store
        .dispatch(Actions.Benefits.EditProviderBenefits, payload)
        .then((r) => {
          if (r.status === 200) {
            this.editOfferDialog = false;
            this.resetModels();
            this.setup();
          }
        });
    },
    providerProfile() {
      this.$router.push({
        name: Component.Protected.Benefit.Provider.Profile,
        params: { id: this.provider.id },
      });
    },
    addBenefit() {
      if (!this.$refs.addBenefitForm.validate()) {
        return false;
      }
      if (this.fileInput.length !== 0 && !Array.isArray(this.fileInput)) {
        const data = this.fileSetup(this.fileInput, "addProviderBenefits");
        this.$store.dispatch(Actions.Firebase.UploadImage, data).then((r) => {
          if (r.status === 200) {
            this.addOfferDialog = false;
            this.setup();
            this.benefit = {};
          }
        });
        return;
      }
      let data = {
        ...this.benefit,
        type: this.benefit.type.map((e) => e),
      };
      this.$store
        .dispatch(Actions.Benefits.AddProviderBenefits, data)
        .then((r) => {
          if (r.status === 200) {
            this.addOfferDialog = false;
            this.setup();
            this.resetModels();
          }
        });
    },
    addNewOffer() {
      this.addOfferDialog = true;
      this.resetModels();
      this.benefit.provider_name = this.companyInfo.name;
      this.benefit.provider_id = parseInt(this.companyInfo.companyId);
      /*  this.benefit.location = [];
      this.benefit.type = []; */
    },
    saveProvider() {
      if (!this.$refs.providerForm.validate()) {
        return false;
      }
      //Logo is uploaded
      if (this.fileInput.length !== 0) {
        const data = this.fileSetup(this.fileInput, "addProviderInfo");
        this.$store
          .dispatch(Actions.Firebase.UploadImage, data)
          .then(() => {
            this.setup();
            this.showProviderDialog = false;
          })
          .catch((err) => {
            console.error("could not upload logo", err);
            this.snackbar = true;
            this.snackbarMessage = "You can only upload image with size < 3mb";
          })
          .finally(() => {
            this.fileInput = null;
          });
        return;
      }
      //Logo is not uploaded
      let data = { ...this.providerInfo };
      this.$store.dispatch(Actions.Benefits.AddProviderInfo, data).then((r) => {
        if (r.status === 200) {
          this.setup();
          this.showProviderDialog = false;
        }
      });
    },
    showProviderInfo() {
      this.providerInfo = { ...this.provider };
      this.showProviderDialog = true;
    },
    fileSetup(file, action) {
      const fileName = `public/${Date.now()}_${file.name.replaceAll(" ", "_")}`;
      const payload =
        action == "addProviderInfo"
          ? { ...this.providerInfo, logo_url: "" }
          : { ...this.benefit, url: "" };
      const data = {
        action: action,
        fileName: fileName,
        metadata: {
          customMetadata: {
            namespace: this.userInfo.namespace,
            uid: this.userInfo.uid,
            type: "image",
          },
        },
        payload: payload,
        id: this.benefit.id,
        content: file,
      };
      return data;
    },
    getAllCountries() {},
    getCountriesByName() {
      this.$store
        .dispatch(Actions.Countries)
        .then(() => {
          this.countries.forEach((el) => {
            this.countriesByName.push(el.name);
          });
        })
        .catch((err) => {
          console.error("Error getting countries", err);
        });
    },
    resetModels() {
      this.benefit = {
        types: [],
        location: [],
      };
    },
    setup() {
      this.getCountriesByName();
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }
      this.$store.dispatch(Actions.Benefits.GetProviderInfo).then((r) => {
        if (this.provider.status === "Approved") {
          this.$store.dispatch(Actions.Benefits.GetProviderBenefits);
          this.isApproved = true;
        }
      });
      this.$store.dispatch(Actions.Company.Info);
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>

<style scoped>
.darkertext,
a {
  color: #272929 !important;
}
</style>